import { instance } from "../../config/intercepter";

// GET Requests

export const getDocCategories = async () => {
  const response = await instance.get(`api/documents/categories`);
  return response?.data;
};

export const getDocuments = async ({categoryId, plateno}) => {
  const response = await instance.get(
    `api/documents/categories/${categoryId}${!!plateno ? `/${plateno}` : ""}`,
    {
      validateStatus: (status) => status < 500, // accept 422 as a resolved response
    }
  );
  return response.data;

};

export const downloadDoc = async ({uuid, categoryId, plateno}) => {
  const response = await instance.get(`api/documents/${uuid}${!!categoryId ? `/${categoryId}`: ""}${!!plateno ? `/${plateno}`: ""}`, {
    responseType: 'blob'
  });
  return response;
};